import { globalConstants, leaderboardConstants } from "../../constants";

const {
  GET_RANKING,
  GET_COMPETITION_RANKING,
  LEADERBOARD_BOAT_CLASSES,
  LEADERBOARD_DATA_NULL,
} = leaderboardConstants;

const initialState = {
  rankings: {},
  competitionRankings: { page: {}, pageData: [] },
  leaderboardBoatClasses: [],
};

const leaderboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_RANKING + globalConstants.SUCCESS:
      return {
        ...state,
        rankings: action.data,
      };
    case GET_COMPETITION_RANKING + globalConstants.SUCCESS:
      return {
        ...state,
        competitionRankings: action.data,
      };
    case LEADERBOARD_BOAT_CLASSES + globalConstants.SUCCESS:
      return {
        ...state,
        leaderboardBoatClasses: action.data,
      };
    case LEADERBOARD_DATA_NULL + globalConstants.SUCCESS:
      return {
        ...state,
        rankings: {},
      };
    default:
      return state;
  }
};

export default leaderboardReducer;
